import { object, string } from 'yup'

const ProviderIdSchema = object().shape({
  id: string().required(),
})

export default ProviderIdSchema
